import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND || "https://taxiapi.oneaihuman.com";

const api = axios.create({
  baseURL: BASE,
  withCredentials: true, // include cookies if backend uses them
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default api;
